module.exports = __webpack_public_path__ + "img/shopNum3.d628706e.jpg";